var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors, opacities } from '../../../theme';
import query from '../../../mediaQueries';
var afterPseudoStyles = "\n:after {\n  content: \"\";\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 100;\n  background-color: ".concat(opacities.rgbaHalfOpacity, ";\n}\n");
// darkened overlay styles - need to use pseudo element
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && afterPseudoStyles;
});
/*
 * Consider: ModalWrapper is only used once and transitionDuration is a constant 250
 * Do we really need to pass it as a prop or is this premature abstraction?
 */
var getTransitionDuration = function (_a) {
    var transitionDuration = _a.transitionDuration;
    return "".concat(transitionDuration, "ms");
};
var ModalWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 25%;\n  overflow: auto;\n  z-index: 500;\n  left: 50%;\n  transform: 'translate(-50%, -60%)';\n  background-color: ", ";\n  opacity: 0;\n  max-height: 85vh;\n  border-radius: 10px;\n  box-shadow: 0 4px 5px 0 ", ",\n    0 3px 14px 3px ", ",\n    0 8px 10px 1px ", ";\n  display: flex;\n  flex-direction: column;\n  transition-property: opacity, transform;\n  transition-duration: ", ", ", ", 0s;\n  transition-timing-function: linear, ease-in-out;\n  width: 95%;\n  margin: auto;\n\n  @media ", " {\n    width: auto;\n    min-width: 450px;\n  }\n"], ["\n  position: fixed;\n  top: 25%;\n  overflow: auto;\n  z-index: 500;\n  left: 50%;\n  transform: 'translate(-50%, -60%)';\n  background-color: ", ";\n  opacity: 0;\n  max-height: 85vh;\n  border-radius: 10px;\n  box-shadow: 0 4px 5px 0 ", ",\n    0 3px 14px 3px ", ",\n    0 8px 10px 1px ", ";\n  display: flex;\n  flex-direction: column;\n  transition-property: opacity, transform;\n  transition-duration: ", ", ", ", 0s;\n  transition-timing-function: linear, ease-in-out;\n  width: 95%;\n  margin: auto;\n\n  @media ", " {\n    width: auto;\n    min-width: 450px;\n  }\n"])), colors.white, opacities.rgbaLight10, opacities.rgbaLight08, opacities.rgbaLight04, getTransitionDuration, getTransitionDuration, query.greaterThanMedium);
var SimpleModal = function (_a) {
    var id = _a.id, children = _a.children, header = _a.header, className = _a.className, footer = _a.footer, isOpen = _a.isOpen, headerRef = _a.headerRef, props = __rest(_a, ["id", "children", "header", "className", "footer", "isOpen", "headerRef"]);
    var TRANSITION_DURATION = 250;
    var _b = useState(false), postAnimationState = _b[0], setPostAnimationState = _b[1];
    var _c = useState({
        transform: 'translate(-50%, -60%)',
        opacity: 0
    }), modalStyles = _c[0], setModalStyles = _c[1];
    useEffect(function () {
        var timer;
        // set focus to the header when modal is opened
        if (isOpen && headerRef.current) {
            headerRef.current.focus();
            // React Ref and styled-components weren't working for this case :(
            setModalStyles({
                transform: 'translate(-50%, -25%)',
                opacity: 1
            });
            timer = setTimeout(function () {
                setPostAnimationState(true);
            }, TRANSITION_DURATION);
        }
        if (!isOpen) {
            // React Ref wasn't working for this case
            setModalStyles({
                transform: 'translate(-50%, -60%)',
                opacity: 0
            });
            timer = setTimeout(function () {
                setPostAnimationState(false);
            }, TRANSITION_DURATION);
        }
        return function () { return clearTimeout(timer); };
    }, [isOpen, headerRef, id]);
    return (_jsx(Overlay, __assign({ isOpen: postAnimationState }, { children: (isOpen || postAnimationState) && (_jsxs(ModalWrapper, __assign({}, props, { role: "dialog", "aria-modal": "true", id: id, "aria-hidden": !isOpen, className: className, transitionDuration: TRANSITION_DURATION, style: modalStyles }, { children: [header, _jsx("div", __assign({ ref: !header ? headerRef : null }, { children: children })), footer] }))) })));
};
export default SimpleModal;
var templateObject_1, templateObject_2;
